export default __webpack_public_path__ + "static/media/NH008.136541b4.jpg";